import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-3">
            分类索引
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            电影频道分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型快速找到你想看的高清电影全集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 transition-colors duration-300 group-hover:bg-accent-200">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 font-mono whitespace-nowrap ml-2">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}